import React from 'react';
import clsx from 'clsx';
import type { SpacingValue } from '../types/spacing';

export interface StackProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * The spacing between stacked components
   */
  space?: SpacingValue | 'none';
  
  /**
   * The content to be stacked vertically
   */
  children: React.ReactNode;

  /**
   * Which direction to lay out the children
   */
  direction?: 'row' | 'column';
}

/**
 * Stack component for vertically stacking components with space between them
 */
export const Stack = React.forwardRef<HTMLDivElement, StackProps>(
  (
    {
      space = 'base',
      className,
      direction = 'column',
      children,
      ...props
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={clsx(
          'prometheus-stack',
          `prometheus-stack--direction-${direction}`,
          `prometheus-stack--space-${space}`,
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Stack.displayName = 'Stack';

export default Stack;